import { render, staticRenderFns } from "./partnerProductPopover.vue?vue&type=template&id=107b252e&"
import script from "./partnerProductPopover.vue?vue&type=script&lang=js&"
export * from "./partnerProductPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports